module.exports = __webpack_public_path__ + "img/img_kiwoom_cnt4_m.881a8a7a.png";